<form
  class="form"
  method="POST"
  (ngSubmit)="onSubmit()"
  [formGroup]="allFormData"
  *ngIf="dynamicElement"
  [attr.id]="formData.formId"
>
  <dynamic-component
    (CreatedComponent)="onCreatedComponent($event)"
    [component]="dynamicElement"
  ></dynamic-component>
</form>
